import each from 'lodash/each';
import moment from 'moment';

export const buildFormData = (data) => {
  const form = new FormData();
  each(data, (v, k) => form.append(k, v));
  return form;
};

export const normalizeUTCDate = (date) => {
  const utcDate = moment.utc(date);
  return moment().set({
    year: utcDate.year(),
    month: utcDate.month(),
    date: utcDate.date(),
  }).toDate();
};

export const api = path => `${process.env.REACT_APP_API}${path}`;

export const apiErrorToStr = (res) => {
  return res.status >= 500
    ? `${res.statusText}. Please contact your system administrator.`
    : res.data.message;
};

export const buildCategoryPath = (name, cat, categories, level) => {
    
    let ret = name;

    if(level>10) return ret;

    if(cat.parent)
    {
        categories.forEach((c) => {
          if( c.id === cat.parent )
          {
            ret = buildCategoryPath( c.name + ' :: ' + ret, c, categories, ++level );
          }
        });
    }

    return ret;
};

export const getCategoryChildrenLevel = (cat, categories, level) => {
    
    let ret = level;

    categories.forEach((c) => {
      if( c.parent === cat.id )
      {
        let newret = getCategoryChildrenLevel( c, categories, level+1 );
        if( newret > ret)
        {
          ret = newret;
        }
      }
    });

    return ret;
};




// WEBPACK FOOTER //
// ./src/utils/index.js